import React from 'react'
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import CtrCorrespondencePanel from "./correspondence/CtrCorrespondencePanel";
import CtrOfferPanel from "./offer/CtrOfferPanel";

const rp = RouterPath.ctrDemand.steps;

function CtrScenesRouter() {
    return (
        <Switch>
            <Route exact path={rp.CTR_DEMAND_ID_CORRESPONDENCE} component={CtrCorrespondencePanel}/>
            <Route exact path={rp.CTR_DEMAND_ID_OFFER_STAGE} component={CtrOfferPanel}/>
            <Route exact path={rp.CTR_DEMAND_ID_OFFER_STAGE_ID} component={CtrOfferPanel}/>
            <Route exact path={rp.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION} component={CtrOfferPanel}/>
        </Switch>
    )
}

CtrScenesRouter.propTypes = {
    classes: PropTypes.any,
}

CtrScenesRouter.defaultProps = {}

export default CtrScenesRouter;